import _ from 'lodash';
import { getColor } from 'common/constants/_colors';
import Text, { Inline } from 'components/base/Text';
import { Flex, Separator } from 'components/base/layout-components';
import {
  DELIVERY_STATES_KEYS,
  DELIVERY_STATES_API_KEYS,
  PROJECTS_VIEW_TYPES,
  PROJECTS_PERIODS_TEXT
} from '../projects.consts.js';
import LegendItem from './LegendItem';
import { LegendLine } from './DeliveryLegend';
import DeliveryPieBreakdown from './DeliveryPieBreakdown';
import usePmViewer from 'common/hooks/pm/usePmViewer';

const DeliveryBreakdown = ({
  issuesData,
  totals = {},
  project = {},
  setSelectedDeliveryState,
  isSingleIterationView = false,
  deliveryType,
  displayType,
  selectedPeriod,
  isPulse
}) => {
  const { issue_chart: type, iterations = [] } = project;
  const {
    [DELIVERY_STATES_API_KEYS.ADDED]: added,
    [DELIVERY_STATES_API_KEYS.ADDED_UNCOMPLETED]: added_uncompleted,
    [DELIVERY_STATES_API_KEYS.COMPLETED]: completed
  } = totals;

  const planned = _.get(
    issuesData.find(({ key }) => key === DELIVERY_STATES_API_KEYS.PLANNED),
    'value',
    0
  );

  const pmViewer = usePmViewer();

  const DeliveryBreakdownAvgValues = () => {
    const avgTitle = _.get(
      PROJECTS_PERIODS_TEXT,
      `${[selectedPeriod]}.avg_title`
    );

    return (
      <Flex height='100%' minWidth='16rem' mr='small'>
        <Separator
          color={getColor('catskillWhite')}
          height='100%'
          margin='0 1.4rem 0 0'
        />
        <Flex height='100%' direction='column'>
          <Flex items='start' direction='column'>
            <Text pb='1rem' color='shuttleGray'>
              <i>{avgTitle}</i>
            </Text>
            <Text size='large' pb='0.5rem'>
              {_.round((completed + added) / iterations.length)}{' '}
              <Inline>
                Completed{' '}
                {deliveryType === 'counts'
                  ? `${pmViewer.ticket.single} counts`
                  : `${pmViewer.storyPoint.plural}`}
              </Inline>
            </Text>
          </Flex>
          <Flex items='start' direction='column'>
            <Text size='large' pb='0.2rem'>
              {_.round((added + added_uncompleted) / iterations.length)}
              <Inline> Added work</Inline>
            </Text>
          </Flex>
        </Flex>
      </Flex>
    );
  };

  switch (displayType) {
    case PROJECTS_VIEW_TYPES.EXTENDED_PIE_VIEW:
      return (
        <Flex
          direction='column'
          width='100%'
          data-testid='deliveryBreakdown-extended-view'
        >
          <Flex items='flex-start' width='100%'>
            <Flex width='19rem'>
              <DeliveryPieBreakdown
                issuesData={issuesData}
                breakdownType={DELIVERY_STATES_API_KEYS.PLANNED}
                isSingleIterationView={isSingleIterationView}
                type={type}
                displayType={displayType}
                setSelectedDeliveryState={setSelectedDeliveryState}
                isPulse={isPulse}
              />
            </Flex>
            <Flex width='19rem'>
              <DeliveryPieBreakdown
                issuesData={issuesData}
                breakdownType={DELIVERY_STATES_API_KEYS.ADDED}
                isSingleIterationView={isSingleIterationView}
                displayType={displayType}
                setSelectedDeliveryState={setSelectedDeliveryState}
                isPulse={isPulse}
              />
            </Flex>
            {!isSingleIterationView && <DeliveryBreakdownAvgValues />}
          </Flex>
        </Flex>
      );
    case PROJECTS_VIEW_TYPES.ITERATION_VIEW:
      return (
        <div data-testid='deliveryBreakdown-iteration-view'>
          <Text size='medium' mb='1.5rem'>
            Delivery by planning
          </Text>
          <Flex pb='small'>
            <div style={{ width: '60px' }}></div>
            <Flex pl='normal' justify='center' minWidth='6rem'>
              <LegendItem
                icon={
                  <LegendLine
                    backgroundColor={
                      DELIVERY_STATES_KEYS[DELIVERY_STATES_API_KEYS.PLANNED]
                        .color
                    }
                  />
                }
                sum={planned}
                name='Total planned'
                isHorizontalView={false}
              />
            </Flex>
          </Flex>
          <DeliveryPieBreakdown
            issuesData={issuesData}
            breakdownType={DELIVERY_STATES_API_KEYS.PLANNED}
            displayType={displayType}
          />
          <Flex height='1.5rem'></Flex>
          <DeliveryPieBreakdown
            issuesData={issuesData}
            breakdownType={DELIVERY_STATES_API_KEYS.ADDED}
            displayType={displayType}
          />
        </div>
      );
    default:
      return <></>;
  }
};

export default DeliveryBreakdown;
